import { IndexType } from '../../seo/constants'
import { Term } from '../../../types/models/Term.model'

export const getIndexTypeForTerm = (term: Term): IndexType => {
  if (term.indexType === 'noIndex') {
    return IndexType.NO_INDEX
  }
  return (term.indexType as IndexType) || IndexType.FULL_INDEX
}
